import gameData from "../../gameData";
import { createCirclePoints, displayPoints } from "./chooseFrost";
import * as ABCya from '@abcya/abcya_phaser';
import sKey from "../../SoundAssetKeys";
import { simpleClickAnimation } from "./makeDonutStart";

export function createChooseSprinkleC(scene)
{
    if(!gameData.makeData.sprinkleCUI)
    {
        sprinkleColors(scene);
        sprinkleCTween();
        
    }
    else
    {
        sprinkleCTween();
    }
}

export function cleanUpSprinkleC(scene)
{
    for(let each in gameData.makeData.sprinkleCUI)
    {
        gameData.makeData.sprinkleCUI[each].destroy();
    }

    gameData.makeData.sprinkleCUI = "";
}

export function sprinkleColors(scene)
{
    const donut = scene.makeDonut;
    scene.questionText.text = "Pick a sprinkle color:";

    const points = createCirclePoints(donut);
    const colorButtons = displayPoints(donut,points);

    for(let each in colorButtons)
    {
        colorButtons[each].setInteractive();
        
        colorButtons[each].on("pointerdown",()=>{
            simpleClickAnimation(colorButtons[each],false);
            scene.sprinkleCont.list.forEach(element => {
                element.setTint(gameData.colorsHex[colorButtons[each].donutColor]);
            });

        });
    }

    gameData.makeData.sprinkleCUI = colorButtons;
}

function sprinkleCTween()
{
    const scene = gameData.makeData.sprinkleCUI[0].scene;
    scene.custSound.playSoundCustom(sKey._colors_tween_in);
    for(let each in gameData.makeData.sprinkleCUI)
    {   
        let button = gameData.makeData.sprinkleCUI[each];
        button.disableInteractive();
        let tween = ABCya.Tweens.addTween(button,600,{x:{start:512, to:button.x}, y:{start:405, to: button.y}, alpha:{start:0,to:1}, delay:each*50});
        tween.on('complete',()=>{
            button.setInteractive();
        });
    }
}

export function sprinkleCOut(scene,back = false)
{
    return new Promise(resolve => {
        let time = 600;
        const scene = gameData.makeData.sprinkleCUI[0].scene;
        scene.custSound.playSoundCustom(sKey._colors_tween_out);
        if(back)ABCya.Tweens.addTween(scene.makeDonut,time,{alpha:0});
        for(let each in gameData.makeData.sprinkleCUI)
        {  
            let button = gameData.makeData.sprinkleCUI[each];

            button.disableInteractive();
            
            ABCya.Tweens.addTween(button,time,{x:512, y:405, delay:each*50, yoyo: true});
            const tween = ABCya.Tweens.addTween(button,time,{alpha:0, delay:each*50},Phaser.Math.Easing.Linear,()=>{
                if(Number(each) === (gameData.makeData.sprinkleCUI.length - 1))
                {
                    resolve();
                }
            });
        }
    });
}